import {ChangeDetectorRef, Component, ElementRef} from "@angular/core";
import {FUIAbstractPop, PopParentHorizontalAlignment, PopParentVerticalAlignment} from "../../../pops/abstract-pop";
import {FUIPopsService} from "../../../pops/pops.service";
import {FUIFormContext} from "../../../form-context/form-context";
import {FUIPopFormContext} from "../../../form-context/pop-form-context";
import {FUIResponsiveService} from "../../../page/responsive.service";
import {FUIEventsService} from "../../../events/events.service";

@Component({
    providers: [{provide: FUIFormContext, useClass: FUIPopFormContext}],
    selector: "fui-image-pop",
    styleUrls: ["./image-pop.component.scss"],
    templateUrl: "./image-pop.component.html"
})
export class FUIImagePopComponent extends FUIAbstractPop {
    parentHorizontalAlignment: PopParentHorizontalAlignment = PopParentHorizontalAlignment.LEFT;
    parentVerticalAlignment: PopParentVerticalAlignment = PopParentVerticalAlignment.DYNAMIC;
    limitWidthToParent: boolean = false;
    adjustHeightToFirstElement: boolean = false;

    constructor(eventsService: FUIEventsService,
                changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                popsService: FUIPopsService,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, elementRef, eventsService, popsService, responsiveService);
    }
}
